import React from "react";
import Modal from "../../components/Modal";
import { useTranslation } from "react-i18next";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import ContactsForm from "../../forms/account/ContactsForm";
import EditCustomerContainer from "../../containers/customers/EditCustomerContainer";

const Edit = ({ handleClose, open, contacts }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("xs"));

  return (
    <Modal
      fullScreen={matches}
      open={open}
      onClose={handleClose}
      title={t("register.title_edit_contacts")}
    >
      {contacts ? (
        <EditCustomerContainer customer={contacts}>
          {({ onSubmit, customer }) => (
            <ContactsForm
              onSubmit={onSubmit}
              initialValues={customer.profile}
            />
          )}
        </EditCustomerContainer>
      ) : null}
    </Modal>
  );
};

export default Edit;
